<template>
  <div class="game-loading" ref="game-loading">
    <div id="Start_game">
        <!-- <p>正在玩命加载中，稍稍等...</p> -->
        <p>等待期间不妨按下【空格键】，放松一下呀～</p>
    </div>
    <div class="game_tip">可通过方向键上下左右控制移动方向</div>
    <div id="map">  <!--地图-->
        <div id="Snak_head"></div> <!--Snak_head-->
    </div>
  </div>
</template>

<script>
import greedySnakeInit from './greedy-snake'
export default {
    name: 'GameLoading',
    data() {
      return {
       callback: ()=> {}
      }
    },
    mounted() {
        const [ keydownGame,  clearIntervalFn ] = greedySnakeInit();
        this.callback = ()=>clearIntervalFn();
        window.addEventListener('keydown', keydownGame);
        this.$once('hook:beforeDestroy', () => {
            clearIntervalFn();
            window.removeEventListener('keydown', keydownGame)
        });
    },
    methods: {
      clearMap() {
        try {
          this.$refs['game-loading'].remove()
        } catch (error) {
          console.log('dom移除失败', error);
        }finally {
          this.callback();
        }
      }
    }
}
</script>
<style>
.game-loading .food_span{
      position: absolute;
      display: block;
      background-color: blue;
      width: 20px;
      height: 20px;
      z-index: 9999;
    }
</style>
<style lang="scss" >
.game-loading {
    background: #fff;
    box-sizing: border-box;
    margin:0;
    padding: 0;
    height: 100%;
    width: 100%;
    font-size: 18px;
    #map{
      position: absolute;
      margin:auto;
      width: 370px;
      height: 370px;
      border: 5px solid rgb(131, 131, 131);
      top:0;
      bottom: 0;
      left:0;
      right:0;
      visibility:hidden;
    }
    .game_tip {
      font-size: 14px;
      color: rgb(175, 175, 175);
      text-align: center;
      position: absolute;
      width: 370px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    #Snak_head{
      width: 20px;
      height: 20px;
      background-color: red;
      position: absolute;
      box-shadow: 0 0 15px 1px black;
    }
    .Snak_body{
      position: absolute;
      width: 20px;
      height: 20px;
      background-color: black;
      box-shadow: 0 0 15px 1px black;
    }
    #Start_game{
      position: absolute;
      margin:auto;
      width: 370px;
      height: 370px; 
      top:0;
      bottom: 0;
      left:0;
      right:0;
      display: flex;
      visibility: visible;
      flex-direction: column;
      justify-content:center;
      align-items: center;
      border:5px solid rgb(131, 131, 131);
      font-size: 14px;
      background-color: rgb(255, 255, 255);
      color: rgb(175, 175, 175);
      z-index: 9999;
       font-weight: normal;
    }
    #Start_game span{
      position: relative; 
    }
    select {
      appearance:none;
      -moz-appearance:none;
      -webkit-appearance:none;
      width:60px;
      height: 30px;
      margin-left:18px;
      outline: none;
      padding-left:15px;
      border-radius: 5px;
    }
    #Start_game:after {
      position: absolute;
      overflow: hidden;
      display: inline-block;
      vertical-align: bottom;
      animation: loading 2s -2s steps(3) infinite;
      content: '';
      padding-bottom: 60px;
      color: #000;
      font-weight: bold;
    }
    @keyframes loading {
      0%{
        content: '正在玩命加载中，稍稍等...';
      }
      7%{
        content: '正在';
      }
      14%{
        content: '正在玩';
      }
      21%{
        content: '正在玩命';
      }
      28%{
        content: '正在玩命加';
      }
      35%{
        content: '正在玩命加载';
      }
      42%{
        content: '正在玩命加载中';
      }
      49%{
        content: '正在玩命加载中，';
      }
      56%{
        content: '正在玩命加载中，稍';
      }
      63%{
        content: '正在玩命加载中，稍稍';
      }
      70%{
        content: '正在玩命加载中，稍稍等';
      }
      77%{
        content: '正在玩命加载中，稍稍等.';
      }
      85%{
        content: '正在玩命加载中，稍稍等..';
      }
      100%{
        content: '正在玩命加载中，稍稍等...';
      }
      
    }
  
}

</style>